module.exports = __webpack_public_path__ + "0dff3468d3fa49746cd6ef242b3e4d11.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/user-directories/manage-user/details/deactivate-sms/deactivate-sms.html
// module id = 1988
// module chunks = 0